module.exports = __webpack_public_path__ + "img/four-nine.34e2ecc8.png";